import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';

/** Checkout de ImpulTienda. */
const CHECKOUT_URL = 'https://troop-night-ready.impultienda.ar/checkout';
const included = ['6 complete volumes, 300+ pages', '60 ready-to-run meetings (M01–M60)', '24 printable worksheets', '5 instant-use bonuses', 'Age Dial for 6–10, 11–14 and 15–17', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="topo-light w-full bg-paper-dark text-pine" data-id="element-172" data-mp="1ru184lrd8efi">
      <div className="mx-auto max-w-2xl px-5 py-14 sm:py-20" data-id="element-173" data-mp="20t4rzrycwxv2">
        <div className="text-center" data-id="element-174" data-mp="20rtkpi5pd7z7">
          <p className="eyebrow text-ember-deep" data-id="element-175" data-mp="3h74lak2p5p9c">Complete package</p>
          <h2 id="pricing-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-176" data-mp="3h9hejtdwnm1p">
            Everything you need for the whole year
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-paper-dark bg-white shadow-card" data-id="element-177" data-mp="4smcel26btw5">
          <div className="bg-forest px-5 py-5 text-center" data-id="element-178" data-mp="9rz2deocdh2y">
            <h3 className="font-display text-xl text-paper sm:text-2xl" data-id="element-179" data-mp="9qe87q5xw05m">
              Troop Night Ready — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-ember" data-id="element-180" data-mp="3d9qq2gvg3evc">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-181" data-mp="3i8bn67fehifk">
            <div className="rounded-2xl bg-forest-deep px-3 pb-4 pt-5" data-id="element-182" data-mp="3n7etdv749up4">
              <ProductStack data-id="element-183" data-mp="3n52755ubsy69" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-184" data-mp="3ry3p5mptxdu2">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-[15px]" data-id="element-185" data-mp="2uheovxgj2jms">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-moss-soft" data-id="element-186" data-mp="2zh0ylwx5dhqu">
                    <CheckIcon className="h-3 w-3 text-moss-deep" aria-hidden="true" data-id="element-187" data-mp="2rfjuj9slggki" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-paper-dark pt-6 text-center" data-id="element-188" data-mp="315mr1jyxccnl">
              <p className="text-[13px] text-pine-soft" data-id="element-189" data-mp="2w71q1ibuloy3">
                Regular price{' '}
                <span className="text-pine-muted line-through" data-id="element-190" data-mp="28hh18it0jxgw">$69 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-191" data-mp="23j5vok9r494h">
                <span className="mt-2.5 font-display text-3xl" data-id="element-192" data-mp="23la7rpht0efu">$</span>
                <span className="font-display text-6xl leading-[0.9] sm:text-7xl" data-id="element-193" data-mp="2ihrg07up5cy6">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-pine-muted" data-id="element-194" data-mp="2djg5duwkuyew">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-195" data-mp="3ox1x9nttne44">
                <span className="rounded border border-ember bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine" data-id="element-196" data-mp="ana6bsdrwnn">
                  Save $42
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-197" data-mp="3nf39517myg05">
                  One-time payment
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-198" data-mp="j0vdouzzsp4d">
                  Lifetime access
                </span>
              </div>

              <p className="mt-4 text-sm text-pine-soft" data-id="element-199" data-mp="a9cvkejhjz8n">
                That&apos;s less than 50¢ a meeting.
              </p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-200" data-mp="e8lo5g2shr2m">
                Get Troop Night Ready now — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-pine-muted" data-id="element-201" data-mp="16qfvhaketgc2">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-pine-soft" data-id="element-202" data-mp="3f8jw0decgl6a">
                <li className="flex items-center gap-1.5" data-id="element-203" data-mp="3a6ujsufdy1gm">
                  <LockIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-204" data-mp="358szk6683w3k" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-205" data-mp="319btpbmvwwxv">
                  <ZapIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-206" data-mp="1t5elila8r9v" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-207" data-mp="3szgmnyopmsap">
                  <ShieldCheckIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-208" data-mp="3o7ox9rhaism5" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-pine-muted" data-id="element-209" data-mp="kjdi41sw9jql">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}